import { Navigate, useLocation } from 'react-router';
import { Home } from './Home';

/** The app opens on Home. An old `/app?post=` deep link still opens that post in Create. */
export function AppIndex() {
  const loc = useLocation();
  if (new URLSearchParams(loc.search).has('post'))
    return (
      <Navigate
        to={{ pathname: '/app/create', search: loc.search }}
        state={loc.state as unknown}
        replace
      />
    );
  return <Home />;
}

/** Retired editor links use the same candidate-review flow as every new generation. */
export function LegacyEditorRedirect() {
  const loc = useLocation();
  return (
    <Navigate
      to={{ pathname: '/app/create', search: loc.search }}
      state={loc.state as unknown}
      replace
    />
  );
}
